import React from "react";

import SectionTextBlock from "components/common/SectionTextBlock";

import { ReactComponent as PersonsPrincipleIcon } from "assets/svgs/persons-principle-icon.svg";

import * as Styled from "./SectionPrinciples.Style";

const SectionPrinciples = () => {
  return (
    <Styled.SectionPrinciplesContainer className="container">
      <div>
        <PersonsPrincipleIcon />
      </div>

      <SectionTextBlock
        title="Princípios"
        description={
          "Realizar concessões de patrocínios de acordo com a ética; respeito às pessoas; dedicação; transparência; segurança e saúde; responsabilidade; inovação; direitos humanos; respeito ao meio ambiente; equidade social; legalidade; impessoalidade; moralidade; eficiência; economicidade; probidade; legitimidade; desenvolvimento sustentável; proteção animal; combate à corrupção; suborno; propina; tráfico de influência; conflitos de interesse e fraudes."
        }
      />
    </Styled.SectionPrinciplesContainer>
  );
};

export default SectionPrinciples;
